

import React from 'react'
import Newnavbar from './Newnavbar'
import Newfooter from './Newfooter'
import sidephone from '../Images/sidephone.png'



const TermsConditions = () => {



  return (
    <div>
            <Newnavbar />

               <div className="bg-[#FFFDF5] min-h-screen px-4 md:px-12 py-8 text-[#333] font-sans">
      <div className="max-w-5xl mx-auto">
        <div className='trust_below_des flex justify-center items-center'>
                        <p className="md:!text-[48px] md:py-[48px] py-[20px]  !text-[24px] !font-bold !text-gray-900 ">
                          Terms & Conditions
                        </p>
                        </div>

        <div className="space-y-6 text-[16px] leading-relaxed">
          <div>
            <h2 className="font-semibold">1. Acceptance of Terms</h2>
            <p>
              By creating an account or using any part of the PayNeft platform, you agree to comply with and be bound by these Terms of Service and our Privacy Policy.
            </p>
          </div>

          <div>
            <h2 className="font-semibold">2. Eligibility</h2>
            <p>
              You must be at least 18 years old and legally eligible to use financial tools and services in your jurisdiction.
            </p>
          </div>

          <div>
            <h2 className="font-semibold">3. User Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized access.
            </p>
          </div>

          <div>
            <h2 className="font-semibold">4. User of Services</h2>
            <p>You agree to use the platform only for lawful purposes and not to:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Violate any applicable laws or regulations</li>
              <li>Engage in fraud or unauthorized financial activity</li>
              <li>Interfere with the platform’s functionality or security</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold">5. Payments and Subscriptions</h2>
            <p>You agree to use the platform only for lawful purposes and not to:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Violate any applicable laws or regulations</li>
              <li>Engage in fraud or unauthorized financial activity</li>
              <li>Interfere with the platform’s functionality or security</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold">6. Data & Privacy</h2>
            <p>
              We collect and use your data in accordance with our Privacy Policy. You retain ownership of your personal and financial data.
            </p>
          </div>

          <div>
            <h2 className="font-semibold">7. Third-Party Services</h2>
            <p>
              Our platform may integrate with third-party tools (e.g., accounting software, payment gateways). We are not responsible for the functionality or content of these services.
            </p>
          </div>

          <div>
            <h2 className="font-semibold">8. Modifications</h2>
            <p>
              We reserve the right to update these Terms at any time. Changes will be posted on our website with a revised effective date.
            </p>
          </div>

          <div>
            <h2 className="font-semibold">9. Termination</h2>
            <p>
              We may suspend or terminate your access to PayNeft for violation of these Terms or for any reason with reasonable notice.
            </p>
          </div>

          <div>
            <h2 className="font-semibold">10. Limitation of Liability</h2>
            <p>
              PayNeft shall not be liable for any indirect, incidental, or consequential damages resulting from the use of the platform.
            </p>
          </div>

          <div>
            <h2 className="font-semibold">11. Governing Law</h2>
            <p>
              These Terms are governed by the laws of [Your Country/State]. Any disputes shall be resolved in the courts of [Jurisdiction].
            </p>
          </div>

          <div>
            <h2 className="font-semibold">12. Contact</h2>
            <p>
              For questions regarding these Terms, please contact us at:
              <br />📧 <a className="text-blue-600 underline" href="mailto:support@payneft.in">support@payneft.in</a>
            </p>
          </div>
        </div>
      </div>
    </div>

            <Newfooter />
      
    </div>
  )
}

export default TermsConditions


